














































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import moment from "moment";
// import { DurationTime } from "@/utils/utils.ts";
import orderInfo from "../orderInfo";
import trainService from "@/service/trainService";
import { Overlay, Step, Steps, Popup, Field, Loading, NoticeBar, Checkbox } from "vant";
import _ from "lodash";
import accountStatus from "../../mall/modules/trainAccountStatus.vue";
import watchOrder from "../../mall/modules/watchOrder.vue";
import { OrderStatus, BusinessType} from "@/model/Base";
@Component({
  name: "trainOrderInfo",
  components: {
    [Overlay.name]: Overlay,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Loading.name]: Loading,
    [Field.name]: Field,
    [NoticeBar.name]: NoticeBar,
    [Checkbox.name]: Checkbox,
    "account-status": accountStatus,
    "watch-order": watchOrder,
  },
})
export default class TrainOrderInfo extends orderInfo {
  @Prop()
  InsurancePrice?: any;

  @Prop()
  ChargePrice?: any;

  service = trainService;
  showRule = false;
  isShowPriceInfo = false;

  accountModel = {
    OuterUserAct: "",
  };
  get isWaitConfirm() {
    return this.order.ClientOrderStatus == OrderStatus.WaitConfirm && this.order.BusinessType != BusinessType.Change;
  }

  formatDate(value: Date, format: string = "YYYY-MM-DD HH:mm:ss") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  duration(value: number) {
    let x = moment.duration(value);
    return x.hours() + "h" + x.minutes() + "m";
  }
  mounted() {
    if (this.isWaitConfirm) {
      (this.$refs.refWatchOrder as any).executeStrategy(this.order.ClientStatusName, this.order.ClientOrderStatus, this.order.UniqueID);
      (this.$refs.refAccoutStatus as any).validOuterUserAct();
    }
  }

  rebooking() {
    (this.$refs.refWatchOrder as any).rebooking(this.order.UniqueID, this);
  }
  errorTips = "";
  isShowVerify = false;
  isShowPopup = false;
  verifyModel: any = {};
  closePopup() {
    this.isShowPopup = false;
    if (!this.isShowVerify) { return }
    this.isShowVerify = false;
    this.verifyModel.UniqueID = this.$route.query.UniqueID as string;
    trainService.validAccountById(this.verifyModel).then(this.checkVerifyResult);
  }
  verifyCallback = () => { };
  checkVerifyResult(json: any) {
    if (json.isSucc) {
      this.verifyCallback()
      return;
    }
    let __self = this;
    __self.verifyModel.randcode = "";
    __self.isShowPopup = true;
    __self.errorTips = __self.errorTips.replace("该账号需要手机发短信核验_", "");
    if (json.statusCode == "234069") {
      // 如果报错有234069就不显示 —— 发送短信提醒
      __self.isShowVerify = true;
    } else {
      __self.errorTips = json.message!;
      __self.isShowVerify = __self.errorTips.indexOf("发送短信666") > -1;
    }
  }
  verifyAccountState(callback: any, params: any) {
    this.verifyCallback = () => callback(params);
    trainService.validOuterUserAct().then(this.checkVerifyResult);
  }
  watchComplate(isSuccess: boolean) {
    if (isSuccess) {
      this.$emit("reload");
    }
  }
}
